import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import Image from 'next/image';
import { ButtonBaseStyled } from './ButtonBaseStyled';

const ButtonControl = (props) => {
  const [, setHovered] = React.useState(false);
  return (
    <ButtonBaseStyled className={props?.outerCustomClass}>
      <Button
        disabled={props?.disabled}
        className={`${props?.customClass} ${props?.iconHover ? 'hasHoverIcon' : ''}`}
        size={props?.size}
        variant={props?.variant}
        style={props?.enableFullWidth ? { width: '100%' } : props?.minWidth && { minWidth: props?.minWidth }}
        onClick={props?.onClick}
        onChange={props?.onChange}
        type={props?.type}
        onMouseEnter={() => {
          setHovered(true);
        }}
        onMouseLeave={() => {
          setHovered(false);
        }}
        onSubmit={props?.onSubmit}
      >
        {props?.icon && props?.iconPosition === 'left' && (
          <div
            className="left"
            style={{ width: props?.iconWidth, height: props?.iconHeight }}
            onClick={props?.onIconClick}
          >
            {props?.iconHover && (
              <div className="hoveredIcon">
                <Image src={props?.iconHover} width={props?.iconWidth} height={props?.iconHeight} alt="" />
              </div>
            )}
            <div className="normalIcon">
              <Image src={props?.icon} width={props?.iconWidth} height={props?.iconHeight} alt="" />
            </div>
          </div>
        )}
        <div className={`${props?.textClass}`}>{props?.text}</div>
        {props?.icon && props?.iconPosition === 'right' && (
          <div
            className={`right ${props?.rightIconOuterClass}`}
            style={{ width: props?.iconWidth, height: props?.iconHeight }}
            onClick={props?.onIconClick}
          >
            {props?.iconHover && (
              <div className="hoveredIcon">
                <Image src={props?.iconHover} width={props?.iconWidth} height={props?.iconHeight} alt="" />
              </div>
            )}
            <div className={`normalIcon ${props?.iconClass}`}>
              <Image src={props?.icon} width={props?.iconWidth} height={props?.iconHeight} alt="" />
            </div>
          </div>
        )}
      </Button>
    </ButtonBaseStyled>
  );
};

ButtonControl.propTypes = {
  customClass: PropTypes.string,
  variant: PropTypes.string,
  text: PropTypes.string,
  type: PropTypes.string,
  size: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  iconHover: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  iconWidth: PropTypes.string,
  iconHeight: PropTypes.string,
  iconPosition: PropTypes.string,
  minWidth: PropTypes.string,
  enableFullWidth: PropTypes.any,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  onSubmit: PropTypes.func,
  outerCustomClass: PropTypes.string,
  rightIconOuterClass: PropTypes.string,
  textClass: PropTypes.string,
  iconClass: PropTypes.string,
  onIconClick: PropTypes.func,
};

ButtonControl.defaultProps = {
  customClass: '',
  variant: 'Primary',
  text: 'Primary Button',
  size: '',
  icon: '',
  iconHover: '',
  iconWidth: '14px',
  iconHeight: '14px',
  iconPosition: 'left',
  minWidth: '40px',
  disabled: false,
  rightIconOuterClass: '',
  textClass: '',
  iconClass: '',
};

export default ButtonControl;
